/* jh-currency-amount.js
   Converts any GBP amount span into the customer's active currency.
   Usage: <span class="jh-amt" data-jh-gbp="4000">GBP40</span>  (amount in GBP pence)
   Loaded from jh-header.liquid, after window.Shopify is available. */
(function () {
  "use strict";

  function formatAmount(gbpPence) {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(cur.rate) || 1;
    var code = cur.active || "GBP";
    var amount = (gbpPence / 100) * rate;
    var lang = document.documentElement.lang || undefined;
    if (lang === "ar") { lang = "ar-u-nu-arab"; }
    var opts = { style: "currency", currency: code };
    try {
      return new Intl.NumberFormat(lang, opts).format(amount);
    } catch (e) {
      return code + " " + amount.toFixed(2);
    }
  }

  function run() {
    var nodes = document.querySelectorAll("[data-jh-gbp]");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var pence = parseInt(el.getAttribute("data-jh-gbp"), 10);
      if (!isNaN(pence)) { el.textContent = formatAmount(pence); }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();